function initializeViewToggle() {
    const productGrid = document.querySelector("#product-grid");
    const listViewButton = document.querySelector(".list-view-switcher");
    const gridViewButton = document.querySelector(".grid-view-switcher");
  
    if (!productGrid || !listViewButton || !gridViewButton) return;
  
    // Remove old event listeners by replacing elements
    const newListViewButton = listViewButton.cloneNode(true);
    const newGridViewButton = gridViewButton.cloneNode(true);
  
    listViewButton.parentNode.replaceChild(newListViewButton, listViewButton);
    gridViewButton.parentNode.replaceChild(newGridViewButton, gridViewButton);
  
    // Add default grid-view class (optional, can check current state instead)
    productGrid.classList.add("grid-view");
  
    newListViewButton.addEventListener("click", function () {
      productGrid.classList.remove("grid-view");
      productGrid.classList.add("list-view");
  
      newListViewButton.classList.add("default-view");
      newGridViewButton.classList.remove("default-view");
    });
  
    newGridViewButton.addEventListener("click", function () {
      productGrid.classList.remove("list-view");
      productGrid.classList.add("grid-view");
  
      newGridViewButton.classList.add("default-view");
      newListViewButton.classList.remove("default-view");
    });
  }
  
  // Run on page load
  document.addEventListener("DOMContentLoaded", function () {
    initializeViewToggle();
  });
  
  // Run again after filtering (Shopify's filter system)
  document.addEventListener("shopify:section:load", function () {
    initializeViewToggle();
  });

  const observer = new MutationObserver(() => {
    // Check if the product grid has been updated
    if (document.querySelector('#product-grid')) {
      // Your script to rerun after filtering
      console.log("ello");
      initializeViewToggle()
    }
  });
  
  // Configure the observer to watch for changes in the child list of the product grid container
  observer.observe(document.getElementById('ProductGridContainer'), {
    childList: true,
    subtree: true,
  });
  